import React, {Component} from "react";
import {changeNumberFormat} from "../../helper/helper";

class TotalTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: "TRY",
            data: [
                {id: 1, value: 'TRY', label: 'TRY', checked: true},
                {id: 2, value: 'USD', label: 'USD'},
                {id: 3, value: 'EUR', label: 'EUR'}
            ],
            currencyPrefix: "₺",
            currencySymbols: {
                'TRY': '₺',
                'USD': '$',
                'EUR': '€'
            },
            kdvOranlar: null,
            invoiceTotal: null,
            taxExclusiveAmount: null,
            resultList: []
        }
        this.onChangeCurrencyCode = this.onChangeCurrencyCode.bind(this);
        this.calculateTotal = this.calculateTotal.bind(this);
        this.calculateKdvOranlar = this.calculateKdvOranlar.bind(this);
        this.calculateInvoiceTotal = this.calculateInvoiceTotal.bind(this);
        this.calculateTaxExclusiveAmount = this.calculateTaxExclusiveAmount.bind(this);
    }

    componentDidMount() {
        if (this.props.showTotal === true) {
            this.calculateTotal(this.state.checked);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.checked !== this.state.checked) {
            this.calculateTotal(this.state.checked);
        }
    }

    componentWillReceiveProps() {
        this.calculateTotal(this.state.checked);
    }

    calculateTotal(currencyCode) {
        let documentType = this.props.documentType;
        let content = this.props.content;
        let currencySymbols = this.state.currencySymbols;
        let str = [];
        let list = [];
        let currencyPrefix;
        for (let i = 0; i < content.length; i++) {
            if (!!currencyCode) {
                if("tmpBelge" === documentType){
                    if (content[i].documentCurrencyCode === currencyCode) {
                        str.push(content[i]);
                    } else {
                    continue;
                }
                }else {
                    if (content[i].currencyCode === currencyCode) {
                        str.push(content[i]);
                    } else {
                        continue;
                    }
                }
            }
        }
        if (currencySymbols[currencyCode] !== undefined) {
            currencyPrefix = currencySymbols[currencyCode];
        }
        this.setState({currencyPrefix});
        if (str.length !== 0) {
                let invoiceTotal = this.calculateInvoiceTotal(str).toFixed(2);
                let kdvOranlar = this.calculateKdvOranlar(str).toFixed(2);
                let taxExclusiveAmount = this.calculateTaxExclusiveAmount(str).toFixed(2);
                list.push({
                    "invoiceTotal": invoiceTotal,
                    "kdvOranlar": kdvOranlar,
                    "taxExclusiveAmount": taxExclusiveAmount
                });
                this.setState({resultList: list, kdvOranlar, invoiceTotal, taxExclusiveAmount});
        } else {
            this.setState({resultList: []});
        }
    }

    calculateKdvOranlar(str) {
        let arr = [];
        let documentType = this.props.documentType;
        for (let j = 0; j < str.length; j++) {
            if ("tmpBelge" === documentType) {
                if (!!str[j].totalKdv18Amount) {
                    arr.push(str[j].totalKdv18Amount);
                } else {
                    arr.push(0);
                }
            } else if ("SERBESTMESLEKMAKBUZ" === documentType) {
                if (!!str[j].kdvOranlar) {
                    arr.push(str[j].kdvOranlar);
                } else {
                    arr.push(0);
                }
            } else {
                if(!!str[j].kdvOranlar) {
                    let kdvOranlar = str[j].kdvOranlar.split(",");
                    for (let i = 0; i < kdvOranlar.length; i++) {
                        if (kdvOranlar[i].includes(":")) {
                            arr.push(kdvOranlar[i].substring(kdvOranlar[i].indexOf(":") + 1));
                        }
                    }
                }else{
                    arr.push(0);
                }
            }
        }
        return arr.map(parseFloat).reduce(function (a, b) {
            return a + b;
        }, 0);
    }

    formatNumber = (value) => {
        if (typeof value === 'number' && !Number.isNaN(value)) {
            return value;
        } else {
            return 0;
        }
    }

    calculateInvoiceTotal(str) {
        let arr = [];
        let documentType = this.props.documentType;
        for (let j = 0; j < str.length; j++) {
            if ("tmpBelge" === documentType) {
                arr.push(str[j].payableAmount);
            }else if("receipt" === documentType){
                arr.push(str[j].documentTotal);
            } else if ("SERBESTMESLEKMAKBUZ" === documentType) {
                let kdv = this.formatNumber(str[j].taxExclusiveAmount) - this.formatNumber(str[j].lineExtensionAmount);
                let invoiceTotal = this.formatNumber(str[j].taxExclusiveAmount) + (kdv > 0 ? kdv : 0);
                arr.push(invoiceTotal);
            } else {
                arr.push(str[j].invoiceTotal);
            }
        }
        return arr.reduce(function (a, b) {
            return a + b;
        }, 0);
    }

    calculateTaxExclusiveAmount(str) {
        let arr = [];
        for (let j = 0; j < str.length; j++) {
            let taxExclusiveAmount = str[j].taxExclusiveAmount;
            arr.push(this.formatNumber(taxExclusiveAmount));
        }
        return arr.reduce(function (a, b) {
            return a + b;
        }, 0);
    }


    onChangeCurrencyCode(e) {
        let target = e.target;
        let self = this;
        if (target.name === "TRY") {
            self.setState({checked: "TRY"});
        } else if (target.name === "USD") {
            self.setState({checked: "USD"});
        } else if (target.name === "EUR") {
            self.setState({checked: "EUR"});
        }
    }


    render() {
        let list = [
            {
                Header: 'Toplam Matrah:',
                accessor: 'taxExclusiveAmount',
                value: changeNumberFormat(this.state.taxExclusiveAmount),
                prefix: this.state.currencyPrefix
            },
            {
                Header: this.props.documentType === 'tmpBelge' ? 'Vergi Toplamı:':'Toplam KDV:',
                accessor: 'kdvOranlar',
                value: changeNumberFormat(this.state.kdvOranlar),
                prefix: this.state.currencyPrefix
            },
            {
                Header: 'Ödenecek Tutar:',
                accessor: 'invoiceTotal',
                value: changeNumberFormat(this.state.invoiceTotal),
                prefix: this.state.currencyPrefix
            }
        ];
        return (
            <div>
                {this.state.resultList.length !== 0 ?
                    list.map((column, j) =>
                    <label style={{
                        fontSize:"13px",
                        textAlign: "center",
                        padding: '18px 25px 0 25px',
                        margin: '0 10px 0 10px',
                        align: "center"
                    }}>{column.Header} {column.value} {column.prefix}</label>
                )
                :
                    list.map((column, j) =>
                        <label style={{
                            fontSize:"13px",
                            textAlign: "center",
                            padding: '18px 25px 0 25px',
                            margin: '0 10px 0 10px',
                            align: "center"
                        }}>{column.Header} {column.prefix}</label>
                    )
                }

                <div className="btn-group" style={{padding: '0 15px 0 15px'}}>
                    <div className="dropdown">
                        <button className="MenuBtn2 listt btn"
                                data-toggle="dropdown">{this.state.checked}
                        </button>
                        <div className="dropdown-menu">
                            {this.state.data.map((data, id) =>
                                <a className="dropdown-item" id={data.id} name={data.value}
                                   onClick={(e) => this.onChangeCurrencyCode(e)}>{data.label}</a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TotalTable;